import { render, staticRenderFns } from "./FollowupDrawer.vue?vue&type=template&id=3d22211e&scoped=true"
import script from "./FollowupDrawer.vue?vue&type=script&lang=js"
export * from "./FollowupDrawer.vue?vue&type=script&lang=js"
import style0 from "./FollowupDrawer.vue?vue&type=style&index=0&id=3d22211e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d22211e",
  null
  
)

export default component.exports